import React from 'react';
import {Bar} from 'react-chartjs-2';

function getRandomColor(i) {
    const letters = '0123456789ABCDEF';
    let color = '#';
    if(i === 0){
        color += 'c3cf37'
    }
    else if(i === 1){
        color += 'FF6384'
    }
    else if(i === 2){
        color += '36A2EB'
    }
    else if(i === 3){
        color += 'FFCE56'
    }
    else if(i === 4){
        color += '4BC0C0'
    }
    else if(i === 5){
        color += '9966FF'
    }
    else if(i === 6){
        color += 'FF9F40'
    }
    else if(i === 7){
        color += 'FF6320'
    }
    else {
        for (let index = 0; i < 6; index++ ) {
            color += letters[Math.floor(Math.random() * 16)];
        }
    }
    return color;
}

const Chart = ({datasets}) => (

    <div className="chart">

        <Bar
            data={{

                labels: ['Counts'],
                datasets: datasets.map((set, index) => ({
                    label: set.description + " - " + set.longDescriptionEn + " " + index,
                    data: [set.count],
                    backgroundColor: getRandomColor(index)

                })),
            }}

            width={100}
            height={50}
            options={{}}
        />
    </div>
);


export default Chart;



// WEBPACK FOOTER //
// ./src/js/components/chart.js